/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from "react";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";

export default function HospitalDataTable({
  selected,
  setSelected,
  hospitalData,
  ishospitalFetching,
}) {
  // console.log(hospitalData)
  const [filterValue, setFilterValue] = React.useState("");

  const filteredData = React.useMemo(() => {
    if (!hospitalData || !filterValue) return hospitalData;
    return hospitalData.filter((hospital) =>
      hospital.name.toLowerCase().includes(filterValue.toLowerCase()),
    );
  }, [hospitalData, filterValue]);

  return (
    <div>
      <div className="flex items-center justify-center py-4">
        <Input
          placeholder="Filter hospital name..."
          value={filterValue}
          onChange={(event) => setFilterValue(event.target.value)}
          className="max-w-sm"
        />
      </div>

      <div className="rounded-md border overflow-auto h-[83vh]">
        <Table>
          {/* <TableCaption>A list of your recent invoices.</TableCaption> */}
          <TableHeader>
            <TableRow>
              <TableHead className="w-[150px]">Name</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Space Allocated</TableHead>
              <TableHead>Allowed Users</TableHead>
              <TableHead>Deleted</TableHead>
              <TableHead>Subscription</TableHead>

              {/* <TableHead className="text-right">Amount</TableHead> */}
            </TableRow>
          </TableHeader>
          <TableBody>
            {ishospitalFetching ? (
              <TableRow>
                <TableCell colSpan={6} className="h-24">
                  <div className="flex justify-center items-center">
                    <Loader2 className="animate-spin" />
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              filteredData?.map((hospital) => (
                <TableRow
                  onClick={() => setSelected(hospital)}
                  key={hospital.name}
                >
                  <TableCell>{hospital.name}</TableCell>
                  <TableCell className="font-medium">{hospital.type}</TableCell>
                  <TableCell>
                    {hospital.space_allocated === null
                      ? "Unlimited"
                      : `${hospital.space_allocated} GB`}
                  </TableCell>
                  <TableCell>{hospital.allowed_users}</TableCell>
                  <TableCell>
                    {hospital.is_deleted === true ? (
                      <Badge className="text-center" variant="destructive">
                        Yes
                      </Badge>
                    ) : (
                      <Badge className=" text-center">No</Badge>
                    )}
                  </TableCell>
                  <TableCell>
                    {hospital.subscription_active === true ? (
                      <Badge className="w-[4.5vw] text-center">Active</Badge>
                    ) : (
                      <Badge
                        className="w-[4.5vw] text-center"
                        variant="destructive"
                      >
                        Inactive
                      </Badge>
                    )}
                  </TableCell>

                  {/* <TableCell className="text-right">{invoice.totalAmount}</TableCell> */}
                </TableRow>
              ))
            )}
          </TableBody>
          {/* <TableFooter>
            <TableRow>
              <TableCell colSpan={3}>Total</TableCell>
              <TableCell className="text-right">$2,500.00</TableCell>
            </TableRow>
          </TableFooter> */}
        </Table>
      </div>
    </div>
  );
}
